import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MockupHttpInterceptor } from "@vattenfall/core";
import { FinnishProductDetailsModel } from "src/app/flows/shared/services/finnish-product-details.model";
import { environment } from "src/environments/environment";

export const data: FinnishProductDetailsModel[] = [
  {
    productId: "1",
    agreementName: "Ilmasto Mix 24 kk",
    monthlyBaseFee: { value: 3.8, unit: "EURO/MONTH" },
    discountedMonthlyBaseFee: { value: 0.0, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 12, unit: "MONTH" },
    productType: "fixed",
    hideMonthlyCost: true,
    energySourceName: "Vesi alkuperä",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
    hideElectricityPriceRow: false,
  },
  {
    productId: "2",
    agreementName: "Testproduct2 FI",
    monthlyBaseFee: { value: 4.9, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 0, unit: "MONTH" },
    productType: "spot",
    hideMonthlyCost: false,
    energySourceName: "Tuuli alkuperä",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
    hideElectricityPriceRow: true,
  },
  {
    productId: "3",
    agreementName: "Testproduct3 FI",
    monthlyBaseFee: { value: 4.9, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 0, unit: "MONTH" },
    productType: "spot",
    hideMonthlyCost: false,
    energySourceName: "Täysydin alkuperä",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
    hideElectricityPriceRow: true,
  },
  {
    productId: "4",
    agreementName: "Ilmasto Mix 24 kk",
    monthlyBaseFee: { value: 3.8, unit: "EURO/MONTH" },
    discountedMonthlyBaseFee: { value: 0.0, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 12, unit: "MONTH" },
    productType: "fixed",
    hideMonthlyCost: true,
    energySourceName: "Aurinko alkuperä",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
    hideElectricityPriceRow: false,
  },
  {
    productId: "5",
    agreementName: "Testproduct5 FI",
    monthlyBaseFee: { value: 4.9, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5975, unit: "EURO_CENT/KWH" },
    contractLength: { value: 24, unit: "MONTH" },
    discountLength: { value: 0, unit: "MONTH" },
    productType: "variable",
    hideMonthlyCost: false,
    energySourceName: "Vesi alkuperä",
    originFee: { value: 0.5, unit: "EURO/MONTH" },
    hideElectricityPriceRow: true,
  },
  {
    productId: "6",
    agreementName: "Optimi Pörssisähko + hinnankiinnitysturva",
    monthlyBaseFee: { value: 5.95, unit: "EURO/MONTH" },
    electricityPrice: { value: 0.5, unit: "EURO_CENT/KWH" },
    spotGuardFee: { value: 4.9, unit: "EURO/MONTH" },
    contractLength: { value: 24, unit: "MONTH" },
    productType: "spot",
    hideMonthlyCost: false,
    hideElectricityPriceRow: false,
  },
];

@Injectable()
export class FinnishProductDetailsServiceMockup extends MockupHttpInterceptor<FinnishProductDetailsModel> {
  constructor() {
    super({
      pathMatcher: "/api/acquisition/products/:productId",
      delay: 250,
      data,
    });
  }
}

export const finnishProductDetailsServiceMockupProvider = environment.production
  ? []
  : {
      provide: HTTP_INTERCEPTORS,
      useClass: FinnishProductDetailsServiceMockup,
      multi: true,
    };
